export default __webpack_public_path__ + "static/media/Mapa.936291ae.png";